<template>
	<div v-if="items && items.filter(entry => entry.show).length" class="PackageIncludes">
        <ul class="PackageIncludes-list">
            <li v-for="item in items.filter(entry => entry.show)" :key="item.key">
                {{ item.title }}
                <aside class="PackageIncludes-help" v-if="item.help && item.help.length">
                    <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="17" height="17"><g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" style="fill: rgb(59, 59, 59);" vector-effect="non-scaling-stroke"/></g></svg>
                    <div class="PackageIncludes-helpTooltip" v-html="item.help"></div>
                </aside>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
	props: {
		items: Array
	}
}
</script>

<style lang="scss">
.PackageIncludes {
    margin: 1.5rem 0 1rem;

    &-list {
		margin: 0;
		padding: 0;
		list-style:none;

		li {
			position: relative;
			padding-left: 3em;
			margin-bottom: 1em;
			line-height: 1.7;

			&:last-child {
				margin-bottom: 0;
			}

			&:before {
				content: ' ';
				position: absolute;
				left: .1em;
				top: .4em;
				width: 1em;
				height: .5em;
				border-left: 2px solid var(--colorBrand);
				border-bottom: 2px solid var(--colorBrand);
				transform: rotate(-45deg);
			}
		}
	}

    &-help {
        display: inline-flex;
        position: relative;
        top: 3px;
        margin-left: 4px;

        svg {
            transition: all .24s ease;
            opacity: .4
        }

        &Tooltip {
            display: none;
            position: absolute;
            top: 50%;
            left: calc(100% + 8px);
            padding: 8px 18px;
            background: #3b3b3b;
            border-radius: 8px;
            font-size: 12px;
            color: #fff;
            min-width: 240px;
            z-index: 4;
            transform: translateY(-50%);
        }

        &:hover svg {
            opacity: 1;
        }

        &:hover &Tooltip {
            display: block;
        }
    }
}
</style>